import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogNameComponent } from '../dialog-name/dialog-name.component';

@Component({
  selector: 'app-dialog-indicadores',
  templateUrl: './dialog-indicadores.component.html',
  styleUrl: './dialog-indicadores.component.scss'
})
export class DialogIndicadoresComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogIndicadoresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string }
  ) { }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
